import React from 'react';

import WpButton from 'Wpds/components/button/WpButton';

type Props = {
  onClick?(): void;
  disabled?: boolean;
};

function DefaultCreateGoalButton({ onClick, disabled }: Props) {
  return (
    <WpButton onClick={onClick} disabled={disabled} qaTest="btn-create-goal">
      Create Goal
    </WpButton>
  );
}

export default DefaultCreateGoalButton;
